export const locations = [
    // --- North America ---
    // USA
    "New York, New York, USA", "Los Angeles, California, USA", "Chicago, Illinois, USA", "Houston, Texas, USA",
    "Phoenix, Arizona, USA", "Philadelphia, Pennsylvania, USA", "San Antonio, Texas, USA", "San Diego, California, USA",
    "Dallas, Texas, USA", "San Jose, California, USA", "Austin, Texas, USA", "Jacksonville, Florida, USA",
    "Fort Worth, Texas, USA", "Columbus, Ohio, USA", "San Francisco, California, USA", "Charlotte, North Carolina, USA",
    "Indianapolis, Indiana, USA", "Seattle, Washington, USA", "Denver, Colorado, USA", "Washington, D.C., USA",
    "Boston, Massachusetts, USA", "El Paso, Texas, USA", "Nashville, Tennessee, USA", "Detroit, Michigan, USA",
    "Oklahoma City, Oklahoma, USA", "Portland, Oregon, USA", "Las Vegas, Nevada, USA", "Memphis, Tennessee, USA",
    "Louisville, Kentucky, USA", "Baltimore, Maryland, USA", "Milwaukee, Wisconsin, USA", "Albuquerque, New Mexico, USA",
    "Tucson, Arizona, USA", "Fresno, California, USA", "Mesa, Arizona, USA", "Sacramento, California, USA",
    "Atlanta, Georgia, USA", "Kansas City, Missouri, USA", "Colorado Springs, Colorado, USA", "Miami, Florida, USA",
    "Raleigh, North Carolina, USA", "Omaha, Nebraska, USA", "Long Beach, California, USA", "Virginia Beach, Virginia, USA",
    "Oakland, California, USA", "Minneapolis, Minnesota, USA", "Tulsa, Oklahoma, USA", "Arlington, Texas, USA",
    "Tampa, Florida, USA", "New Orleans, Louisiana, USA", "Wichita, Kansas, USA", "Bakersfield, California, USA",
    "Cleveland, Ohio, USA", "Aurora, Colorado, USA", "Anaheim, California, USA", "Honolulu, Hawaii, USA",
    "Santa Ana, California, USA", "Riverside, California, USA", "Corpus Christi, Texas, USA", "Lexington, Kentucky, USA",
    "Henderson, Nevada, USA", "Stockton, California, USA", "Saint Paul, Minnesota, USA", "Cincinnati, Ohio, USA",
    "St. Louis, Missouri, USA", "Pittsburgh, Pennsylvania, USA", "Greensboro, North Carolina, USA", "Lincoln, Nebraska, USA",
    "Anchorage, Alaska, USA", "Plano, Texas, USA", "Orlando, Florida, USA", "Irvine, California, USA",
    "Newark, New Jersey, USA", "Durham, North Carolina, USA", "Chula Vista, California, USA", "Toledo, Ohio, USA",
    "Fort Wayne, Indiana, USA", "St. Petersburg, Florida, USA", "Laredo, Texas, USA", "Jersey City, New Jersey, USA",
    "Chandler, Arizona, USA", "Madison, Wisconsin, USA", "Lubbock, Texas, USA", "Scottsdale, Arizona, USA",
    "Reno, Nevada, USA", "Buffalo, New York, USA", "Gilbert, Arizona, USA", "Glendale, Arizona, USA",
    "North Las Vegas, Nevada, USA", "Winston-Salem, North Carolina, USA", "Chesapeake, Virginia, USA", "Norfolk, Virginia, USA",
    "Fremont, California, USA", "Garland, Texas, USA", "Irving, Texas, USA", "Hialeah, Florida, USA",
    "Richmond, Virginia, USA", "Boise, Idaho, USA", "Spokane, Washington, USA", "Baton Rouge, Louisiana, USA",
    "Tacoma, Washington, USA", "San Bernardino, California, USA", "Modesto, California, USA", "Fontana, California, USA",
    "Des Moines, Iowa, USA", "Moreno Valley, California, USA", "Santa Clarita, California, USA", "Fayetteville, North Carolina, USA",
    "Birmingham, Alabama, USA", "Oxnard, California, USA", "Rochester, New York, USA", "Port St. Lucie, Florida, USA",
    "Grand Rapids, Michigan, USA", "Huntsville, Alabama, USA", "Salt Lake City, Utah, USA", "Frisco, Texas, USA",
    "Yonkers, New York, USA", "Amarillo, Texas, USA", "Glendale, California, USA", "Huntington Beach, California, USA",
    "McKinney, Texas, USA", "Montgomery, Alabama, USA", "Augusta, Georgia, USA", "Aurora, Illinois, USA",
    "Akron, Ohio, USA", "Little Rock, Arkansas, USA", "Tempe, Arizona, USA", "Columbus, Georgia, USA",
    "Overland Park, Kansas, USA", "Grand Prairie, Texas, USA", "Tallahassee, Florida, USA", "Cape Coral, Florida, USA",
    "Mobile, Alabama, USA", "Knoxville, Tennessee, USA", "Shreveport, Louisiana, USA", "Worcester, Massachusetts, USA",
    "Ontario, California, USA", "Vancouver, Washington, USA", "Sioux Falls, South Dakota, USA", "Chattanooga, Tennessee, USA",
    "Brownsville, Texas, USA", "Fort Lauderdale, Florida, USA", "Providence, Rhode Island, USA", "Newport News, Virginia, USA",
    "Rancho Cucamonga, California, USA", "Santa Rosa, California, USA", "Peoria, Arizona, USA", "Oceanside, California, USA",
    "Elk Grove, California, USA", "Salem, Oregon, USA", "Pembroke Pines, Florida, USA", "Eugene, Oregon, USA",
    "Garden Grove, California, USA", "Cary, North Carolina, USA", "Fort Collins, Colorado, USA", "Corona, California, USA",
    "Springfield, Missouri, USA", "Jackson, Mississippi, USA", "Alexandria, Virginia, USA", "Hayward, California, USA",
    "Clarksville, Tennessee, USA", "Lakewood, Colorado, USA", "Lancaster, California, USA", "Salinas, California, USA",
    "Palmdale, California, USA", "Hollywood, Florida, USA", "Springfield, Massachusetts, USA", "Macon, Georgia, USA",
    "Kansas City, Kansas, USA", "Sunnyvale, California, USA", "Pomona, California, USA", "Killeen, Texas, USA",
    "Escondido, California, USA", "Pasadena, Texas, USA", "Naperville, Illinois, USA", "Bellevue, Washington, USA",
    "Joliet, Illinois, USA", "Murfreesboro, Tennessee, USA", "Midland, Texas, USA", "Rockford, Illinois, USA",
    "Paterson, New Jersey, USA", "Savannah, Georgia, USA", "Bridgeport, Connecticut, USA", "Torrance, California, USA",
    "McAllen, Texas, USA", "Syracuse, New York, USA", "Surprise, Arizona, USA", "Denton, Texas, USA",
    "Roseville, California, USA", "Thornton, Colorado, USA", "Miramar, Florida, USA", "Pasadena, California, USA",
    "Mesquite, Texas, USA", "Olathe, Kansas, USA", "Dayton, Ohio, USA", "Carrollton, Texas, USA",
    "Waco, Texas, USA", "Orange, California, USA", "Fullerton, California, USA", "Charleston, South Carolina, USA",

    // Canada
    "Toronto, Ontario, Canada", "Montreal, Quebec, Canada", "Vancouver, British Columbia, Canada", "Calgary, Alberta, Canada",
    "Edmonton, Alberta, Canada", "Ottawa, Ontario, Canada", "Winnipeg, Manitoba, Canada", "Quebec City, Quebec, Canada",
    "Hamilton, Ontario, Canada", "Kitchener, Ontario, Canada", "London, Ontario, Canada", "Victoria, British Columbia, Canada",
    "Halifax, Nova Scotia, Canada", "Oshawa, Ontario, Canada", "Windsor, Ontario, Canada", "Saskatoon, Saskatchewan, Canada",
    "Regina, Saskatchewan, Canada", "St. John's, Newfoundland and Labrador, Canada", "Kelowna, British Columbia, Canada",
    "Barrie, Ontario, Canada", "Sherbrooke, Quebec, Canada", "Guelph, Ontario, Canada", "Abbotsford, British Columbia, Canada",
    "Kingston, Ontario, Canada", "Sudbury, Ontario, Canada", "Trois-Rivières, Quebec, Canada", "Moncton, New Brunswick, Canada",

    // Mexico
    "Mexico City, Mexico", "Guadalajara, Jalisco, Mexico", "Monterrey, Nuevo Leon, Mexico", "Puebla, Puebla, Mexico",
    "Tijuana, Baja California, Mexico", "Leon, Guanajuato, Mexico", "Juarez, Chihuahua, Mexico", "Zapopan, Jalisco, Mexico",
    "Merida, Yucatan, Mexico", "San Luis Potosi, San Luis Potosi, Mexico", "Aguascalientes, Aguascalientes, Mexico",
    "Hermosillo, Sonora, Mexico", "Saltillo, Coahuila, Mexico", "Mexicali, Baja California, Mexico", "Culiacan, Sinaloa, Mexico",
    "Cancun, Quintana Roo, Mexico", "Acapulco, Guerrero, Mexico", "Chihuahua, Chihuahua, Mexico", "Morelia, Michoacan, Mexico",

    // --- Europe ---
    // UK
    "London, England, UK", "Birmingham, England, UK", "Manchester, England, UK", "Leeds, England, UK",
    "Glasgow, Scotland, UK", "Liverpool, England, UK", "Newcastle, England, UK", "Sheffield, England, UK",
    "Bristol, England, UK", "Belfast, Northern Ireland, UK", "Edinburgh, Scotland, UK", "Cardiff, Wales, UK",
    "Nottingham, England, UK", "Leicester, England, UK", "Southampton, England, UK", "Portsmouth, England, UK",
    "Plymouth, England, UK", "Brighton, England, UK", "Reading, England, UK", "Aberdeen, Scotland, UK",

    // Germany
    "Berlin, Germany", "Hamburg, Germany", "Munich, Germany", "Cologne, Germany", "Frankfurt, Germany",
    "Stuttgart, Germany", "Dusseldorf, Germany", "Dortmund, Germany", "Essen, Germany", "Leipzig, Germany",
    "Bremen, Germany", "Dresden, Germany", "Hanover, Germany", "Nuremberg, Germany", "Duisburg, Germany",

    // France
    "Paris, France", "Marseille, France", "Lyon, France", "Toulouse, France", "Nice, France",
    "Nantes, France", "Strasbourg, France", "Montpellier, France", "Bordeaux, France", "Lille, France",
    "Rennes, France", "Reims, France",

    // Italy
    "Rome, Italy", "Milan, Italy", "Naples, Italy", "Turin, Italy", "Palermo, Italy",
    "Genoa, Italy", "Bologna, Italy", "Florence, Italy", "Bari, Italy", "Catania, Italy",
    "Venice, Italy", "Verona, Italy",

    // Spain
    "Madrid, Spain", "Barcelona, Spain", "Valencia, Spain", "Seville, Spain", "Zaragoza, Spain",
    "Malaga, Spain", "Murcia, Spain", "Palma, Spain", "Las Palmas, Spain", "Bilbao, Spain",

    // Rest of Europe (Major Cities)
    "Amsterdam, Netherlands", "Rotterdam, Netherlands", "The Hague, Netherlands", "Utrecht, Netherlands",
    "Brussels, Belgium", "Antwerp, Belgium", "Ghent, Belgium",
    "Vienna, Austria", "Graz, Austria", "Linz, Austria",
    "Zurich, Switzerland", "Geneva, Switzerland", "Basel, Switzerland", "Bern, Switzerland",
    "Dublin, Ireland", "Cork, Ireland",
    "Stockholm, Sweden", "Gothenburg, Sweden", "Malmo, Sweden",
    "Copenhagen, Denmark", "Aarhus, Denmark",
    "Oslo, Norway", "Bergen, Norway",
    "Helsinki, Finland", "Espoo, Finland",
    "Lisbon, Portugal", "Porto, Portugal",
    "Athens, Greece", "Thessaloniki, Greece",
    "Warsaw, Poland", "Krakow, Poland", "Lodz, Poland", "Wroclaw, Poland",
    "Prague, Czech Republic", "Brno, Czech Republic",
    "Budapest, Hungary",
    "Bucharest, Romania", "Cluj-Napoca, Romania",
    "Sofia, Bulgaria",
    "Belgrade, Serbia",
    "Zagreb, Croatia",
    "Kyiv, Ukraine", "Kharkiv, Ukraine", "Odesa, Ukraine", "Lviv, Ukraine",
    "Minsk, Belarus",
    "Moscow, Russia", "Saint Petersburg, Russia", "Novosibirsk, Russia", "Yekaterinburg, Russia", "Kazan, Russia",

    // --- Asia ---
    // India
    "Mumbai, Maharashtra, India", "Delhi, Delhi, India", "Bangalore, Karnataka, India", "Hyderabad, Telangana, India",
    "Ahmedabad, Gujarat, India", "Chennai, Tamil Nadu, India", "Kolkata, West Bengal, India", "Surat, Gujarat, India",
    "Pune, Maharashtra, India", "Jaipur, Rajasthan, India", "Lucknow, Uttar Pradesh, India", "Kanpur, Uttar Pradesh, India",
    "Nagpur, Maharashtra, India", "Indore, Madhya Pradesh, India", "Thane, Maharashtra, India", "Bhopal, Madhya Pradesh, India",
    "Visakhapatnam, Andhra Pradesh, India", "Pimpri-Chinchwad, Maharashtra, India", "Patna, Bihar, India", "Vadodara, Gujarat, India",
    "Ghaziabad, Uttar Pradesh, India", "Ludhiana, Punjab, India", "Agra, Uttar Pradesh, India", "Nashik, Maharashtra, India",
    "Faridabad, Haryana, India", "Meerut, Uttar Pradesh, India", "Rajkot, Gujarat, India", "Kalyan-Dombivli, Maharashtra, India",
    "Vasai-Virar, Maharashtra, India", "Varanasi, Uttar Pradesh, India", "Srinagar, Jammu and Kashmir, India",
    "Aurangabad, Maharashtra, India", "Dhanbad, Jharkhand, India", "Amritsar, Punjab, India", "Navi Mumbai, Maharashtra, India",
    "Allahabad, Uttar Pradesh, India", "Ranchi, Jharkhand, India", "Howrah, West Bengal, India", "Coimbatore, Tamil Nadu, India",
    "Jabalpur, Madhya Pradesh, India", "Gwalior, Madhya Pradesh, India", "Vijayawada, Andhra Pradesh, India", "Jodhpur, Rajasthan, India",
    "Madurai, Tamil Nadu, India", "Raipur, Chhattisgarh, India", "Kota, Rajasthan, India", "Guwahati, Assam, India",
    "Chandigarh, Chandigarh, India", "Solapur, Maharashtra, India", "Hubballi-Dharwad, Karnataka, India", "Mysore, Karnataka, India",

    // China
    "Shanghai, China", "Beijing, China", "Guangzhou, China", "Shenzhen, China", "Chengdu, China",
    "Tianjin, China", "Wuhan, China", "Dongguan, China", "Chongqing, China", "Hangzhou, China",
    "Nanjing, China", "Xi'an, China", "Harbin, China", "Shenyang, China", "Jinan, China",
    "Hong Kong", "Macau",

    // Japan
    "Tokyo, Japan", "Yokohama, Japan", "Osaka, Japan", "Nagoya, Japan", "Sapporo, Japan",
    "Fukuoka, Japan", "Kobe, Japan", "Kyoto, Japan", "Kawasaki, Japan", "Saitama, Japan",
    "Hiroshima, Japan", "Sendai, Japan",

    // South Korea
    "Seoul, South Korea", "Busan, South Korea", "Incheon, South Korea", "Daegu, South Korea",
    "Daejeon, South Korea", "Gwangju, South Korea",

    // Southeast Asia
    "Bangkok, Thailand", "Nonthaburi, Thailand", "Nakhon Ratchasima, Thailand",
    "Ho Chi Minh City, Vietnam", "Hanoi, Vietnam", "Da Nang, Vietnam",
    "Jakarta, Indonesia", "Surabaya, Indonesia", "Bandung, Indonesia", "Medan, Indonesia",
    "Kuala Lumpur, Malaysia", "George Town, Malaysia", "Johor Bahru, Malaysia",
    "Singapore, Singapore",
    "Manila, Philippines", "Quezon City, Philippines", "Davao City, Philippines", "Cebu City, Philippines",
    "Yangon, Myanmar", "Mandalay, Myanmar",
    "Phnom Penh, Cambodia",

    // Middle East
    "Dubai, UAE", "Abu Dhabi, UAE", "Sharjah, UAE",
    "Riyadh, Saudi Arabia", "Jeddah, Saudi Arabia", "Mecca, Saudi Arabia", "Medina, Saudi Arabia",
    "Doha, Qatar",
    "Kuwait City, Kuwait",
    "Manama, Bahrain",
    "Muscat, Oman",
    "Amman, Jordan",
    "Beirut, Lebanon",
    "Tel Aviv, Israel", "Jerusalem, Israel", "Haifa, Israel",
    "Istanbul, Turkey", "Ankara, Turkey", "Izmir, Turkey", "Bursa, Turkey", "Antalya, Turkey",
    "Tehran, Iran", "Mashhad, Iran", "Isfahan, Iran",

    // --- Australia & Oceania ---
    "Sydney, Australia", "Melbourne, Australia", "Brisbane, Australia", "Perth, Australia", "Adelaide, Australia",
    "Gold Coast, Australia", "Canberra, Australia", "Newcastle, Australia", "Wollongong, Australia",
    "Auckland, New Zealand", "Wellington, New Zealand", "Christchurch, New Zealand", "Hamilton, New Zealand",

    // --- South America ---
    "Sao Paulo, Brazil", "Rio de Janeiro, Brazil", "Salvador, Brazil", "Brasilia, Brazil", "Fortaleza, Brazil", "Belo Horizonte, Brazil",
    "Buenos Aires, Argentina", "Cordoba, Argentina", "Rosario, Argentina",
    "Santiago, Chile", "Valparaiso, Chile",
    "Bogota, Colombia", "Medellin, Colombia", "Cali, Colombia",
    "Lima, Peru", "Arequipa, Peru",
    "Caracas, Venezuela", "Maracaibo, Venezuela",
    "Quito, Ecuador", "Guayaquil, Ecuador",
    "Montevideo, Uruguay",
    "Asuncion, Paraguay",
    "La Paz, Bolivia", "Santa Cruz, Bolivia",

    // --- Africa ---
    "Cairo, Egypt", "Alexandria, Egypt", "Giza, Egypt",
    "Lagos, Nigeria", "Kano, Nigeria", "Ibadan, Nigeria", "Abuja, Nigeria",
    "Johannesburg, South Africa", "Cape Town, South Africa", "Durban, South Africa", "Pretoria, South Africa",
    "Nairobi, Kenya", "Mombasa, Kenya",
    "Addis Ababa, Ethiopia",
    "Casablanca, Morocco", "Rabat, Morocco", "Marrakesh, Morocco",
    "Algiers, Algeria",
    "Accra, Ghana", "Kumasi, Ghana",
    "Abidjan, Ivory Coast",
    "Dakar, Senegal",
    "Dar es Salaam, Tanzania",
    "Kampala, Uganda",
    "Luanda, Angola",
    "Kinshasa, DR Congo",
    "Tunis, Tunisia"
];
